import { Relation } from 'types/enums/AppointmentEnum';
import { InsuranceInUserProfileType } from 'types/InsuranceType';

export const showIcon = (insuranceArr?: InsuranceInUserProfileType[]) => {
  //return !!(insuranceArr && insuranceArr[0]?.relation === Relation.SELF);
  return !!insuranceArr?.length;
};
